import { confirmTreasuryItemProduct, loadingTreasuryItem } from 'actions'
import { P_INDIVIDUAL_TREASURY_ITEM_LOADING } from 'constants/ConfigProcessNames'
import { IConfigFieldsForm } from 'models/Budget'
import {
	IConfirmTreasuryItemProductPayload,
	ILoadingTreasuryItemParams
} from 'models/IndividualTreasuryItem'
import React, { Component, forwardRef, Ref } from 'react'
import { Col, Row } from 'react-bootstrap'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import IndividualSearch from './IndividualSearch'
import IndividualTreasuryItemLoadingTable from './IndividualTreasuryItemLoadingTable'

interface IndividualTreasuryItemLoadingProps extends WithTranslation {
	idOperacion?: string
	config: IConfigFieldsForm
	loadingTreasuryItem: (payload: ILoadingTreasuryItemParams) => void
	confirmTreasuryItemProduct: (
		payload: IConfirmTreasuryItemProductPayload
	) => void
	callBackReturn?: any
}

interface IndividualTreasuryItemLoadingState {}

class IndividualTreasuryItemLoadingComponent extends Component<
	IndividualTreasuryItemLoadingProps,
	IndividualTreasuryItemLoadingState
> {
	individualRef: any = React.createRef()

	constructor(props: IndividualTreasuryItemLoadingProps) {
		super(props)
		this.state = {}
	}

	preventAddToCart = () => {
		if (this.individualRef.current) {
			this.individualRef.current.handleSubmit()
		}
	}

	handleConfirmComponent = () => {
		const { idOperacion, callBackReturn } = this.props
		this.props.confirmTreasuryItemProduct({
			callBackReturn,
			params: {
				idOperacion: idOperacion || ''
			}
		})
	}

	handleMoveArrow = () => {}

	handleItemAddToCart = (params: any) => {
		const { idOperacion } = this.props

		this.props.loadingTreasuryItem({
			cantidad: params.cantidad,
			desc_prod: params.desc_prod,
			idOperacion: idOperacion || '',
			neto: params.neto,
			niprod: params.Niprod
		})
	}

	render() {
		const { idOperacion, config } = this.props

		const tableProps = {
			idOperacion: idOperacion || ''
		}

		return (
			<Row>
				<Col sm={12}>
					<IndividualSearch
						formRef={this.individualRef}
						fields={config.campos}
						idOperacion={idOperacion || ''}
					/>
				</Col>
				<Col sm={12}>
					<IndividualTreasuryItemLoadingTable {...tableProps} />
				</Col>
			</Row>
		)
	}
}

const mapStateToProps = ({ voucher }: any) => {
	const config = voucher.config
		? voucher.config[P_INDIVIDUAL_TREASURY_ITEM_LOADING]
		: null

	return { config }
}

const mapDispatchToProps = { loadingTreasuryItem, confirmTreasuryItemProduct }

const IndividualTreasuryItemLoadingWithRef = forwardRef(
	function LoadInventoryItemsTableWrapper(
		props: IndividualTreasuryItemLoadingProps,
		ref: Ref<IndividualTreasuryItemLoadingComponent>
	) {
		return <IndividualTreasuryItemLoadingComponent {...props} ref={ref} />
	}
)

export default withTranslation('', { withRef: true })(
	connect(mapStateToProps, mapDispatchToProps, null, {
		forwardRef: true
	})(IndividualTreasuryItemLoadingWithRef)
)
